import './Login.scss';
import React, { useCallback, useEffect } from 'react'
import { Button, Card, Col, Container, Row, Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useAuth } from '../contexts/auth';
import { useFullScreenLoader } from '../contexts/fullScreenLoader';
import Cookies from 'js-cookie';
import { Navigate, useLocation } from 'react-router-dom';
import Logo from '../components/common/Logo';
import { useKeycloak } from '@react-keycloak/web';

const loginSubtitle = window.__env.LOGIN_SUBTITLE || "Provide your credentials to sign in.";

export default function Login() {
  const location = useLocation();
  const { token, setToken } = useAuth();
  const cookie = Cookies.get(window.__env.AUTH_TOKEN_NAME || "alida-token");

  const { showLoader, hideLoader } = useFullScreenLoader();
  const { initialized, keycloak } = useKeycloak();

  useEffect(() => {
    if (location.hash) showLoader();

    if (keycloak.authenticated) {
      // TODO: set expires based on response (in model and application creation too)
      Cookies.set(window.__env.AUTH_TOKEN_NAME || "alida-token", keycloak.token!);
      Cookies.set(window.__env.AUTH_REFRESH_TOKEN_NAME || "alida-refresh-token", keycloak.refreshToken!);
      setToken(keycloak.token);
      hideLoader();
    }
  }, [location.hash, keycloak?.token, keycloak?.refreshToken, keycloak?.authenticated, showLoader, hideLoader, setToken])

  const login = useCallback(() => {
    keycloak?.login();
  }, [keycloak]);

  if (token || cookie) return <Navigate to={window.__env.AFTER_LOGIN_ROUTE || "/dashboard"} />;

  return (
    <Container className="login-container">
      <Card>
        <Card.Body>
          <div className="text-center mb-5">
            <Logo width={300} className="my-4" />
            {/* <Card.Title>Login</Card.Title> */}
            {loginSubtitle?.length > 0 && <Card.Subtitle className="text-muted">{loginSubtitle}</Card.Subtitle>}
            {/* <Card.Subtitle className="text-muted">Push the button below to sign in.</Card.Subtitle> */}
          </div>

          <Row className="justify-content-center">
            <Col sm={8} md={5}>
              <Button size="sm" className="w-100" disabled={!initialized} onClick={login}>
                <FontAwesomeIcon icon={solid('sign-in')} />
                <span className="ms-2">Login</span>
              </Button>

              <div className="mt-3 text-center">
                {initialized
                  ? (
                    <>
                      <FontAwesomeIcon className="text-success" icon={solid('circle')} />
                      <small className="ms-2">Connected to Keycloak</small>
                    </>
                  )
                  : (
                    <>
                      <Spinner size="sm" />
                      <small className="ms-2">Connecting to Identity Manager...</small>
                    </>
                  )}
              </div>
            </Col>
            {/* <Col xs={12} className="mt-3 text-center">
              <small className="text-muted">
                If you do not have an account, please apply sending a mail to <a href="mailto:info@alidalab.it">info@alidalab.it</a>
              </small>
            </Col> */}
          </Row>
        </Card.Body>
      </Card>
    </Container>
  )
}